
import HeroSection from './components/HeroSection';
import TrustBand from './components/TrustBand';
import FocusSection from './components/FocusSection';
import ServicesSection from './components/ServicesSection';
import IllustrationSection from './components/IllustrationSection';
import IndependentSection from './components/IndependentSection';
import OurFocusSection from './components/OurFocusSection';
import TestimonialSection from './components/TestimonialSection';
import CTASection from './components/CTASection';

const HomePage = () => {
  return (
    <div>
      <HeroSection />
      <TrustBand />
      <FocusSection />
      <ServicesSection />
      <IllustrationSection />
      <IndependentSection />
      <OurFocusSection />
      <TestimonialSection />
      <CTASection />
    </div>
  );
};

export default HomePage;
